import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import Main from '../../../main';

/**
 * シタエポイント入力クラス
 */
export default class ItemControllerShitaePointInput {
  dotList: marietta.core.Point[] = [];

  callbackOnComplete: Function;

  callbackOnInterrupt: Function;

  x: number;

  y: number;

  // lastTime:number;
  currentLine: marietta.webcad.control.parts.StrechLine;

  currentText: marietta.webcad.control.parts.StrechLineText;

  type: string;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  public spt: SVGSprite;

  public dotImage: SVGSprite;

  private moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   */
  constructor() {
    (<HTMLElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';

    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    // ドットイメージの作成
    const _dotImage: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    _dotImage.setAttribute('id', 'dotImage');
    this.tarLayer.viewObj.appendChild(_dotImage);
    this.dotImage = new SVGSprite(_dotImage);

    // ペンの生成
    const targetItem = document.getElementById('lib_icon_pen');
    const viewObj = <SVGElement>targetItem.querySelector('svg > g').cloneNode(true);
    viewObj.setAttribute('id', 'controller_pen');
    this.tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);

    // イベント設定
    const stage = document.querySelector('#layerGroup');
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchmove', this.followMouse, { passive: false });
      stage.addEventListener('touchstart', this.makeDot, { passive: false });
    } else {
      stage.addEventListener('mousemove', this.followMouse);
      stage.addEventListener('mousedown', this.makeDot);
    }

    const scope: ItemControllerShitaePointInput = this;
    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.followMouseHandler();
      }
    };
    ua = null;
    this.forbidOtherEvents();
    // スケールアップデート
    this.updatePickers();
  }

  /**
   * イベント禁止設定
   * ステージホイールイベント禁止
   * keyイベント禁止
   * stage以外のクリックイベント禁止
   */
  private forbidOtherEvents() {
    const self = this;
    marietta.webcad.WebCADGlobal.scrollerManager.scrollEnable = false;
    document.addEventListener('keydown', self.preventKeyEvents);
    document.getElementById('itemMenuWrap').addEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('header').addEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('footer').addEventListener('click', self.preventOutsideStageClickEvents);
    const allButtons = document.getElementsByTagName('button');
    for (let i = 0; i < allButtons.length; i += 1) {
      allButtons[i].addEventListener('click', self.preventKeyEvents);
    }
    const allInput = document.getElementsByTagName('input');
    for (let i = 0; i < allInput.length; i += 1) {
      allInput[i].addEventListener('click', self.preventKeyEvents);
    }
    const allSelect = document.getElementsByTagName('input');
    for (let i = 0; i < allSelect.length; i += 1) {
      allSelect[i].addEventListener('mousedown', self.preventKeyEvents);
    }
    document.getElementById('checkShitaeOpacity').addEventListener('mousedown', self.preventKeyEvents);
    document.getElementById('btnLoadShitae').removeEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeLoadBtnHandler);
    document.getElementById('btnEditShitae').removeEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeEditBtnHandler);
    document.getElementById('btnStageScaleFit').removeEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit);
    document.getElementById('btnStageScalePlus').removeEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementPlus);
    document.getElementById('btnStageScaleMinus').removeEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementMinus);
    document.getElementById('checkSelectMode').removeEventListener('click', Main.btnHeaderSelectModeClickEventHandler);
    document.getElementById('btnUndo').removeEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.undo);
    document.getElementById('btnRedo').removeEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.redo);
    document.getElementById('btnSave2').removeEventListener('click', Main.saveBtnClickEventHandler);
    document.querySelector('#webcadClose > a').removeEventListener('click', Main.webcadCloseBtnClickEventHandler);
    document.querySelector('#btn3D').removeEventListener('click', marietta.webcad.WebCADGlobal.dimensionMenu.btn3DEventHandler);
  }

  /**
   * イベント禁止を解除
   */
  private allowOtherEvents() {
    const self = this;
    marietta.webcad.WebCADGlobal.scrollerManager.scrollEnable = true;
    document.removeEventListener('keydown', self.preventKeyEvents);
    document.getElementById('itemMenuWrap').removeEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('header').removeEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('footer').removeEventListener('click', self.preventOutsideStageClickEvents);
    const allButtons = document.getElementsByTagName('button');
    for (let i = 0; i < allButtons.length; i += 1) {
      allButtons[i].removeEventListener('click', self.preventKeyEvents);
    }
    const allInput = document.getElementsByTagName('input');
    for (let i = 0; i < allInput.length; i += 1) {
      allInput[i].removeEventListener('click', self.preventKeyEvents);
    }
    const allSelect = document.getElementsByTagName('input');
    for (let i = 0; i < allSelect.length; i += 1) {
      allSelect[i].removeEventListener('mousedown', self.preventKeyEvents);
    }
    document.getElementById('checkShitaeOpacity').removeEventListener('mousedown', self.preventKeyEvents);
    document.getElementById('btnLoadShitae').addEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeLoadBtnHandler);
    document.getElementById('btnEditShitae').addEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeEditBtnHandler);
    document.getElementById('btnStageScaleFit').addEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit);
    document.getElementById('btnStageScalePlus').addEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementPlus);
    document.getElementById('btnStageScaleMinus').addEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementMinus);
    document.getElementById('checkSelectMode').addEventListener('click', Main.btnHeaderSelectModeClickEventHandler);
    document.getElementById('btnUndo').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.undo);
    document.getElementById('btnRedo').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.redo);
    document.getElementById('btnSave2').addEventListener('click', Main.saveBtnClickEventHandler);
    document.querySelector('#webcadClose > a').addEventListener('click', Main.webcadCloseBtnClickEventHandler);
    document.querySelector('#btn3D').addEventListener('click', marietta.webcad.WebCADGlobal.dimensionMenu.btn3DEventHandler);
  }

  /**
   * キーイベントの禁止
   */
  private preventKeyEvents = (e: Event) => {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }

  /**
   * ステージ以外の領域のイベント禁止
   */
  private preventOutsideStageClickEvents = (e: Event) => {
    e.stopImmediatePropagation();
    e.preventDefault();
    if (!(<HTMLElement>e.target).closest('#layerGroup')) {
      return false;
    }
    return true;
  }

  /**
   * マウスの動きでトリガー
   */
  private followMouseHandler() {
    // e.preventDefault();
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = 1;
    this.spt.x = Math.round(newPoint.x / snapUnit) * snapUnit;
    this.spt.y = Math.round(newPoint.y / snapUnit) * snapUnit;
    this.spt.update();

    // 最後のラインの伸び縮
    if (this.currentLine) {
      this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
    }
  }

  /**
   * マウス追従
   */
  followMouse = (e: MouseEvent) => {
    // e.preventDefault();

    this.moveMouseEvent = e;
    /*
      var newPoint:marietta.core.Point = new marietta.core.Point( this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY );
      var snapUnit = marietta.webcad.WebCADGlobal.PIX_IN_GRID * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit;
      if( this.type == "site" ) snapUnit = 1;        //敷地の場合は、吸着なし
      this.spt.x = Math.round(newPoint.x / snapUnit) * snapUnit;
      this.spt.y = Math.round(newPoint.y / snapUnit) * snapUnit;
      this.spt.update();

      //最後のラインの伸び縮
      if( this.currentLine != undefined ){
          this.currentLine.secondDot = new marietta.core.Point( this.spt.x, this.spt.y );
          this.currentText.secondDot = new marietta.core.Point( this.spt.x, this.spt.y );
      }
      */
  }

  /**
   * マウス追従終了
   */
  stopFollowMouse = () => {
    const stage = document.querySelector('#layerGroup');
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.removeEventListener('touchmove', this.followMouse);
      stage.removeEventListener('touchstart', this.makeDot);
    } else {
      stage.removeEventListener('mousemove', this.followMouse);
      stage.removeEventListener('mousedown', this.makeDot);
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;
    }
    ua = null;

    // ペンの削除
    if (document.getElementById('controller_pen')) {
      document.getElementById('controller_pen').remove();
    }
    (<HTMLElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
  }

  /**
   * ドットの作成
   * @param MouseEvent
   */
  makeDot = (e: MouseEvent) => {
    e.stopImmediatePropagation();
    // ステージ以外がクリックされたら、囲み入力モードを終了

    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    newPoint.x = Math.round(newPoint.x);
    newPoint.y = Math.round(newPoint.y);

    // const time: Date = new Date();
    // const nowTime: number = time.getTime();

    // 始点に近すぎるところがクリックされたら点を追加しない
    if (this.dotList.length > 2) {
      const startPoint: marietta.core.Point = this.dotList[0] as marietta.core.Point;
      if (marietta.core.Point.distance(newPoint, startPoint) < 10) {
        return;
      }
    }

    // 前のライン類の終点指定
    if (this.currentLine) {
      this.currentLine.secondDot = newPoint;
      this.currentText.secondDot = newPoint;
    }

    // 頂点情報の保持
    this.dotList.push(newPoint);

    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;
    // 頂点の作成
    const _dot: Element = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
    _dot.setAttribute('cx', '0');
    _dot.setAttribute('cy', '0');
    _dot.setAttribute('rx', String(5 * sc));
    _dot.setAttribute('ry', String(5 * sc));
    _dot.setAttribute('fill', '#00ff00');
    _dot.setAttribute('id', `dot${this.dotList.length}`);
    const dot: SVGSprite = new SVGSprite(_dot);
    // ドットイメージの作成
    this.dotImage.addChild(dot);
    dot.x = newPoint.x;
    dot.y = newPoint.y;
    dot.update();

    // ラインの作成
    this.currentLine = new marietta.webcad.control.parts.StrechLine(this.dotImage, this.dotList.length);
    this.currentLine.firstDot = newPoint;
    this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
    // テキスト
    this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
    this.currentText.firstDot = newPoint;
    this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);

    // 最終クリック時間
    // this.lastTime = nowTime;

    // 2点目がクリックされたら終了
    if (this.dotList.length === 2) {
      this.endMakeShape();
    }
  }

  /**
   * 形状作成の終了
   */
  endMakeShape() {
    // マウスの追従終了
    this.stopFollowMouse();
    // 作成用モジュールなど削除する
    this.viewObj.remove();
    this.dotImage.remove();
    // 入力された数値をダイアログに表示
    const distance: number = marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(this.dotList[0], this.dotList[1]));
    const num = Math.round(distance);
    const rotate: number = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(this.dotList[0], this.dotList[1]);
    if (!(marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.ShitaeFitDialog)) return;
    (marietta.webcad.WebCADGlobal.currentDialog as marietta.webcad.view.dialog.ShitaeFitDialog).lineSize = num;
    (marietta.webcad.WebCADGlobal.currentDialog as marietta.webcad.view.dialog.ShitaeFitDialog).rotate = rotate;

    // その他のイベント禁止を解除
    this.allowOtherEvents();
    // ダイアログを再表示
    (marietta.webcad.WebCADGlobal.currentDialog as marietta.webcad.view.dialog.ShitaeFitDialog).show();
  }

  /**
   *
   * HTMLElementの取得
   */
  public get viewObj(): HTMLElement {
    return this.spt.element;
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;
    this.spt.scaleX = sc;
    this.spt.scaleY = sc;
    this.spt.update();
  }

  /**
   * 囲み入力の中断
   */
  interrupt() {
    // カーソルをもとに戻す
    (<HTMLElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
    // マウスの追従終了
    this.stopFollowMouse();
    // 作成用モジュールなど削除する
    this.viewObj.remove();
    this.dotImage.remove();
  }
}
